export const SELECTOR = 'video';

export const NO_CAPTIONS_FLAG = 'none';

export const BASE_AD_URL =
  'https://pubads.g.doubleclick.net/gampad/ads?iu=/5805113/TexasTribune_Video_640x360&description_url=https%3A%2F%2Fwww.texastribune.org&env=vp&impl=s&correlator=&tfcd=0&npa=0&gdfp_req=1&output=vast&sz=640x360|640x480&unviewed_position_start=1';
